import React from 'react'
import {Heading} from '@miro-site/core'

import {HeadlineOptions} from './types'
import {DefaultTheme} from 'styled-components'

export const HEADLINE_SIZES = {
  medium: 'h1',
  mid: 'h2',
  small: 'h3',
  tiny: 'h4',
}

type HeadlineProps = HeadlineOptions & {
  headingProps?: React.ComponentProps<typeof Heading>
  className?: string
}

const HEADLINE_COLORS: Record<string, keyof DefaultTheme['colors']> = {
  white: 'primaryWhite',
}

const Headline = ({
  align,
  size,
  tag,
  color,
  text,
  headingProps = {},
  className,
}: HeadlineProps): React.ReactElement => {
  headingProps.$styles = {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    ...(headingProps.$styles || {}),
  }

  const props = {
    $align: align,
    $variant: size ? HEADLINE_SIZES[size] : 'h3',
    as: tag,
    color: color ? HEADLINE_COLORS[color] : undefined,
    className: className,
    ...headingProps,
  }

  if (typeof text === 'string') {
    return <Heading dangerouslySetInnerHTML={{__html: text}} {...props} />
  }

  return <Heading {...props}>{text}</Heading>
}

export default Headline
